import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';
import { condensedStyles } from 'core/components/theme/condensed-layout';
import { clearNavRail } from 'core/components/nav-rail/nav-rail-width';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    // height: 'auto',
    position: 'fixed',
    bottom: 0,
    left: 0,
    boxShadow: '0 -2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
    width: '100%',
    backgroundColor: theme.colors.footer_background_primary,
    ...reskinStyles(theme, { boxShadow: theme.surfaceShadows.footer }),
    zIndex: 100,
    ...condensedStyles(theme, clearNavRail(theme))
  },
  containerWithWarning: {
    height: 136
  },
  containerWithWarningAndLongError: {
    height: 190
  },
  footerInner: {
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    padding: theme.spacing(6, 8)
    // gap: theme.spacing(0, 8)
  },
  innerFooterWithWarning: {
    padding: theme.spacing(0, 8, 10)
  },
  subtitle: {
    fontWeight: 300
  },
  footerItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2, 3),
    flexWrap: 'wrap'
  },
  right: {
    flex: '1 0 auto'
  },
  btn: {
    maxWidth: 350
  },
  btnLabel: {
    fontWeight: 500,
    fontSize: 16,
    color: theme.colors.white
  },
  rewriteBtn: {
    color: theme.colorPalette.orange_75
  },
  label: {
    fontSize: 24,
    fontWeight: 400,
    color: theme.colorPalette.green_90
  },
  subLabel: {
    fontSize: 12,
    '& span': {
      fontWeight: 600
    }
  },
  leftFormLabel: {
    fontSize: 24,
    fontWeight: 500
  },
  withLeftForm: {
    maxWidth: 400,
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    margin: 'auto',
    gap: 0
  },
  last: {
    justifyContent: 'center'
  },
  checkbox: {
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  footerWarning: {
    textAlign: 'center',
    width: '100%',
    height: 36,
    backgroundColor: theme.colorPalette.orange_50,
    color: theme.colorPalette.white,
    justifyContent: 'space-around',
    alignItems: 'center',
    fontSize: 14,
    padding: theme.spacing(2)
  },
  iconXSmall: {
    height: 14,
    marginRight: theme.spacing(1),
    transform: 'rotate(180deg)'
  },
  link: {
    color: theme.colorPalette.white,
    display: 'inline-block',
    textDecoration: 'underline'
  },
  changeType: {
    fontWeight: 600
  }
});

export default makeStyles(styles);
